// @flow

export default class Company {
  id: string;
  company_business_role: string;
  name: string;
  business_name: string;
  rfc: string;
  address: string;
  company_type: string;
  legal_representative: string;
  homie_name: string;
  legal_entity_name: string;
  foundation_year: string;
  invoiced_amount: string;
  company_operation_years: string;
  number_of_branches: string;
  working_company: string;
  company_size: string;
  is_for_other_tenant: string;
  phone: string;
  number_of_branches:  number;

  constructor(data: any = {}) {
    data = data !== null ? data : {};
    this.id = data.id || '';
    this.company_business_role = data.company_business_role || '';
    this.name = data.name || '';
    this.business_name = data.business_name || '';
    this.rfc = data.rfc || '';
    this.address = data.address || '';
    this.company_type = data.company_type || '';
    this.legal_representative = data.legal_representative || '';
    this.homie_name = data.homie_name || '';
    this.legal_entity_name = data.legal_entity_name || '';
    this.foundation_year = data.foundation_year || '';
    this.invoiced_amount = data.invoiced_amount || '';
    this.company_operation_years = data.company_operation_years || '';
    this.number_of_branches = data.number_of_branches || '';
    this.working_company = data.working_company || '';
    this.company_size = data.company_size || '';
    this.is_for_other_tenant = data.is_for_other_tenant || '';
    this.phone = data.phone || '';
    this.number_of_branches = data.number_of_branches || 0;   
  }
}
